import { useTranslation } from 'react-i18next';
import type { InventoryPolicyControlScope } from '../model/controlCenter.types';

interface InventoryPolicyControlScopeSelectorProps {
  scope: InventoryPolicyControlScope;
  onChange: (scope: InventoryPolicyControlScope) => void;
}

export function InventoryPolicyControlScopeSelector({
  scope,
  onChange,
}: InventoryPolicyControlScopeSelectorProps) {
  const { t } = useTranslation();

  return (
    <div className="inline-flex items-center rounded-lg border border-gray-200 bg-white p-1 shadow-sm">
      {(['central', 'stores'] as InventoryPolicyControlScope[]).map((option) => {
        const active = scope === option;
        return (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
              active
                ? 'bg-[#1681ba] text-white'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            {t(`inventoryPolicyControl.scope.options.${option}`)}
          </button>
        );
      })}
    </div>
  );
}
